import * as React from 'react';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';

import { useUtilityContext } from '../../../utility-provider';
import { encryptQueryParam, decryptQueryParam } from '../../../utility/util';
import { getMultipleData } from "../../../api/DataManage"
import { setStoreCode, setLocationLinkObj, setExistingSejStoreObj } from '../../../features/rviewStoreSlice';

import {
    Box,
    Button,
    Select,
    MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUserContext } from '../../../user-provider';
import Computer from '@mui/icons-material/Computer';
import PhoneIphone from '@mui/icons-material/PhoneIphone';
import ResearchBranchModal from '../ResearchBranchModal';
import ConfirmDialog from '../../common/ConfirmDialog';
import { hasScroll } from "../../common/Scroll";
import { userLogging } from '../../../utility/firestore';
import { LOCAL_CONSTANT } from '../../common/Const';

export interface resultProps {
    props: {
    }
}

const StoreMenu: React.FC<resultProps> = ({ props }) => {
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const [userData, setUserData] = React.useState<any>({});
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    //URLパラメータ
    const [storecode, setStorecode] = React.useState("");
    const [planAreaId, setPlanAreaId] = React.useState("");
    const [linkPlanAreaId, setLinkPlanAreaId] = React.useState("");
    // 受付簿
    const objLocationLink = useAppSelector((state) => state.rviewStoreData.locationLink);
    const objExistingSejStore = useAppSelector((state) => state.rviewStoreData.existingSejStore);
    // 出店時調査書用のlocationBaseデータ
    const [locationBaseData, setLocationBaseData] = React.useState<any>(null);
    //モーダル開閉フラグ(調査書枝選択画面)
    const [researchBranchOpen, setResearchBranchOpen] = React.useState(false);
    const [value, setValue] = React.useState<string>("")
    // ダイアログ開閉フラグ
    const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
    // 活性管理用フラグ
    const [activeFlag, setActiveFlag] = React.useState(true);

    //URLパラメータ取得
    React.useEffect(() => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        hasScroll();
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            if (res[0] && res[0].trim() !== '') {
                setStorecode(res[0]);
            } else {
                // storecodeが存在しない場合はダイアログを表示
                setErrorDialogOpen(true);
            }
        }).catch((e:any) => {
            console.log(e);
            // 復号化エラーの場合もダイアログを表示
            setErrorDialogOpen(true);
        }).finally(() => {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    },[]);

    //ユーザー取得タイミングによる画面制御
    React.useEffect(() => {
        if (JSON.parse(user.userData || 'null') !== null) {
            setUserData(JSON.parse(user.userData));
        }
    }, [user]);

    React.useEffect(() => {
        if (storecode && userData) {
            selectLocationLink()
            dispatch(setStoreCode(storecode))
        }
    }, [storecode, userData])

    // 出店時調査書ボタンの活性制御フラグ設定
    React.useEffect(() => {
        if (objExistingSejStore?.ctycode && userData && Array.isArray(userData.manage_cities)) {
            if(userData.manage_cities.includes("ALL")){
                setActiveFlag(false);
            }else{
                setActiveFlag(!userData.manage_cities.includes(objExistingSejStore.ctycode))
            }  
        }
    }, [objExistingSejStore, userData])

    // 画面表示 userLogging
    React.useEffect(() => {
        if (storecode && user.userData) {
            const decryptedUrl = window.location.pathname + `?storeCode=${storecode}&referrer=rview-store`;
            const encryptedUrl = window.location.pathname + window.location.search;
            
            userLogging(
                LOCAL_CONSTANT.FUNCTION_NAME.STOREMENU_DISPLAY,
                {
                    decrypted_url: decryptedUrl,
                    encrypted_url: encryptedUrl
                },
                user
            );
        }
    }, [storecode, user]);

    const selectLocationLink = () => {
        if (Object.keys(userData).length > 0) {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner()
            }
            // 候補地呼び出し
            callApi('locationLink')
                .then((res: any) => {
                    dispatch(setLocationLinkObj(res.getLocationLink))
                    // 既存店
                    dispatch(setExistingSejStoreObj(res.getExistingSejStore[0]))
                    // 既存店のprop_site_noがあればgetLocationBaseを呼び出す
                    if (res.getExistingSejStore[0]?.prop_site_no) {
                        return callApi('locationBase', res.getExistingSejStore[0].prop_site_no);
                    }
                }).then((res: any) => {
                    if (res) {
                        setLocationBaseData(res.getLocationBase);
                    }
                }).catch((e) => {
                    console.log(e);
                    setErrorDialogOpen(true);
                }).finally(() => {
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                })
        }
    }

    const callApi = async (target: string, propSiteNo?: string) => {
        const param: any = []
        if (target === 'locationLink') {
            param.push({
                mode: 'getLocationLink',
                storeCode: storecode,
            })
            param.push({
                mode: 'getExistingSejStore',
                storeCode: storecode,
            })
            return await getMultipleData(param)
        } else if (target === 'locationBase') {
            param.push({
                mode: 'getLocationBase',
                plan_area_id: propSiteNo,
                branch: "1",
            })
            return await getMultipleData(param)
        }
    }

    //モーダルオープン(調査書枝選択画面)
    const handleResearchBranchOpen = () => {
        setResearchBranchOpen(true);
    };

    const selectHandler = (event: any) => {
        setValue(event.target.value)
        objLocationLink.map((row: any) => {
            if (row.link_plan_area_id === event.target.value) {
                setPlanAreaId(row.use_plan_area_id)
                setLinkPlanAreaId(row.link_plan_area_id)
            }
        })
    }

    const hasDisabled = () => {
        const hasStoreCode = Boolean(objExistingSejStore.store_code);
        const hasPlanAreaId = Boolean(planAreaId);
        return !(hasStoreCode && hasPlanAreaId);
    }

    // 出店時調査書ボタンの活性制御
    const hasOpeningSurveyDisabled = () => {
        return !locationBaseData || locationBaseData.length === 0 || activeFlag;
    }

    // 出店時調査書ボタン押下時の処理
    const handleOpeningSurveyMove = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        // URLパラメータ暗号化
        const param = `planAreaId=${objExistingSejStore.prop_site_no}&referrer=rview-store`;
        encryptQueryParam(param).then((res) => {
            const url = "/Planareamenu?" + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    const handleMove = (location: string) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        // URLパラメータ暗号化
        const param = `planAreaId=${planAreaId}&referrer=rview-store`;
        encryptQueryParam(param).then((res) => {
            const url = location + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    return (
        <>
            <Box sx={{ margin: '0 auto', padding: '10px' }}>
                <Box sx={{ margin: '10px 0', textAlign: 'center' }}>立地調査</Box>
                <Box sx={{ margin: '10px 0', display: 'flex', justifyContent: 'center' }}>{objExistingSejStore.store_code}：{objExistingSejStore.tenpo_name}</Box>
                <Box sx={{ margin: '20px 0', textAlign: 'center' }}>
                    <Select
                        sx={{ margin: '10px 0', minWidth: '260px', width: '260px' }}
                        value={value}
                        onChange={(event) => selectHandler(event)}
                    >
                        {objLocationLink?.map((row: any) => (
                            <MenuItem
                                key={row.link_plan_area_id}
                                value={row.link_plan_area_id}>
                                {'候補地No：' + row.link_plan_area_id}</MenuItem>
                        ))}
                    </Select>
                    <Box>
                        <Button
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }} 
                            variant="contained" 
                            color="success" 
                            disabled={hasDisabled()}
                            onClick={handleResearchBranchOpen} 
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <Computer />
                            </Box>調査書
                        </Button>
                    </Box>
                    <Box>
                        <Button
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }}
                            variant="contained"
                            color="success"
                            disabled={hasOpeningSurveyDisabled()}
                            onClick={handleOpeningSurveyMove}
                        >
                            <Box
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <Computer />
                            </Box>出店時調査書
                        </Button>
                    </Box>
                    <Box>
                        <Button 
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }} 
                            variant="contained" 
                            color="success" 
                            disabled={hasDisabled()}
                            onClick={()=>{handleMove("/Photo/upload?")}}
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <PhoneIphone />
                            </Box>写真登録
                        </Button>
                    </Box>
                    <Box>
                        <Button 
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }} 
                            variant="contained" 
                            color="success" 
                            disabled={hasDisabled()}
                            onClick={()=>{handleMove("/TrafficVolume/select?")}}
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <PhoneIphone />
                            </Box>通行量調査
                        </Button>
                    </Box>
                    <Box sx={{
                        '& .MuiButton-root:hover': { backgroundColor: '#205766' }
                    }}>
                        <Button 
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px', backgroundColor: '#31859c' }} 
                            variant="contained" 
                            color="success"
                            disabled={hasDisabled()}
                            onClick={()=>{handleMove("/TrafficConfirmationScreen?")}}
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                            </Box>計測結果確認
                        </Button>
                    </Box>
                </Box>
                <ResearchBranchModal props={{ modalOpen: researchBranchOpen, setModalOpen: setResearchBranchOpen, planAreaId: planAreaId }} />
                <ConfirmDialog props={{
                    open: errorDialogOpen,
                    handleModal: setErrorDialogOpen,
                    onCancel: () => {},
                    onExecution: () => {},
                    onCancelRegist: () => {},
                    mode: "",
                    body: LOCAL_CONSTANT.ERROR_MESSAGE.PLAN_AREA_ID_NOT_FOUND,
                    confirmCancel: "",
                    confirmOk: "",
                    confirmCancelRegist: "",
                }} />
            </Box>
        </>
    )
}

export default StoreMenu;
